var map = {
	"./1-1.jpg": "EGuS",
	"./2-2.jpg": "ahi6",
	"./2.jpg": "lieJ",
	"./bg3.jpg": "AoA8",
	"./h5-bg3.jpg": "oWru"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NKc3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news ^\.\/.*\.jpg$
// module id = NKc3
// module chunks = 0